import React from 'react';

/**
 * Round icon-only button atom (header actions, toolbars, close buttons).
 * Theme-safe via .lf-icon-btn (theme-overrides.css).
 *
 *   <IconButton icon="fa-sun" title="Toggle theme" onClick={...} />
 */
const IconButton = ({ icon, onClick, title = undefined, active = false, disabled = false, className = '' }) => (
  <button
    type="button"
    className={`lf-icon-btn ${active ? 'lf-icon-btn--active' : ''} ${className}`.trim()}
    onClick={onClick}
    title={title}
    aria-label={title}
    disabled={disabled}
  >
    <i className={`fa ${icon}`} aria-hidden="true"></i>
  </button>
);

export default IconButton;
